import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'inventory-date-range',
  templateUrl: './inventory-date-range.component.html',
  styleUrls: ['./inventory-date-range.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InventoryDateRangeComponent implements OnInit {

  @Input() checkInDate : Date;
  @Input() checkOutDate: Date;
  constructor() { }

  ngOnInit() {
  }

  public get isDateRangeWithInSameYear() : boolean
  {
     return this.checkInDate.getFullYear() === this.checkOutDate.getFullYear();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/inventory-date-range/inventory-date-range.component.ts